import React, { useState } from "react";
import { Box, SelectChangeEvent } from "@mui/material";

import { SelectByDate } from "../index";
import SelectCustomPeriod from "../../../pages/Financials/components/SelectCustomPeriod";

import { DATES_VALUE } from "../../../constants";
import { TRenderDay } from "../StyledDatePicker";

interface IProps {
  getReport: (startDate: string, endDate: string, isAllTime?: boolean) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setReport: (a: any) => void;
  setIsLoading: (a: boolean) => void;
  initialDateBy?: DATES_VALUE;
  renderDay?: TRenderDay;
  excludeDates?: DATES_VALUE[];
}

export const SelectByDateWithCustomPeriod = ({
  getReport,
  setReport,
  setIsLoading,
  initialDateBy = DATES_VALUE.today,
  renderDay,
  excludeDates = [],
}: IProps): React.ReactElement => {
  const [dateBy, setDateBy] = useState<DATES_VALUE>(initialDateBy);

  const [customPeriodStart, setCustomPeriodStart] = useState("");
  const [customPeriodEnd, setCustomPeriodEnd] = useState("");

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value !== DATES_VALUE.customPeriod) {
      setIsLoading(true);
      setCustomPeriodStart("");
      setCustomPeriodEnd("");
    }

    if (value === DATES_VALUE.customPeriod) {
      setReport([]);
    }

    setDateBy(value as DATES_VALUE);
  };

  return (
    <Box display="flex" flexDirection="row">
      <SelectByDate
        dateBy={dateBy}
        handleChange={handleChange}
        periodStart={customPeriodStart}
        periodEnd={customPeriodEnd}
        getReport={getReport}
        excludeDates={excludeDates}
      />

      {dateBy === DATES_VALUE.customPeriod && (
        <SelectCustomPeriod
          autoOk
          customPeriodStart={customPeriodStart}
          customPeriodEnd={customPeriodEnd}
          setCustomPeriodStart={setCustomPeriodStart}
          setCustomPeriodEnd={setCustomPeriodEnd}
          isActive={!!dateBy}
          renderDay={renderDay}
        />
      )}
    </Box>
  );
};

export default SelectByDateWithCustomPeriod;
